<template>
  <div>
    <div class="modal fade" tabindex="-1" role="dialog" id="edit">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title">{{ form.modal.title }}</h4>
          </div>
          <div class="modal-body">
            <form
              @submit.prevent="onSubmit()"
              @keydown="form.errors.clear($event.target.id)"
            >
              <input type="hidden" name="id" v-model="form.data.id" />

              <div
                class="form-group"
                :class="{ 'has-error': form.errors.has('name') }"
              >
                <label class="control-label">Site Name or ID</label>
                <input
                  type="text"
                  class="form-control"
                  id="name"
                  v-model="form.data.name"
                />
                <span
                  class="help-block"
                  v-if="form.errors.has('name')"
                  v-text="form.errors.get('name')"
                ></span>
              </div>

              <div
                class="form-group"
                :class="{ 'has-error': form.errors.has('contractId') }"
              >
                <label class="control-label">Contract</label>
                <div class="form-group">
                  <select class="form-control" v-model="form.data.contractId">
                    <option></option>
                    <option v-for="item in contracts" v-bind:value="item.id">{{
                      item.attributes.name
                    }}</option>
                  </select>
                </div>
                <span
                  class="help-block"
                  v-if="form.errors.has('contractId')"
                  v-text="form.errors.get('contractId')"
                ></span>
              </div>

              <CoordinateEditor
                :errors="form.errors.get('geojson')"
                :geojsonData="this.geojson"
              />

              <div class="flex">
                <div
                  class="form-group"
                  :class="{ 'has-error': form.errors.has('address') }"
                  style="width:100%;"
                >
                  <label class="control-label"
                    >Address or Physical Location</label
                  >
                  <input
                    type="text"
                    class="form-control"
                    id="address"
                    v-model="form.data.address"
                  />
                  <span
                    class="help-block"
                    v-if="form.errors.has('address')"
                    v-text="form.errors.get('address')"
                  ></span>
                </div>
                <button
                  @click="tryGeocodeAddress($event)"
                  class="btn btn-blue"
                  style="flex:0; height:3.4rem; margin-top:2.5rem; margin-left:1.5rem;"
                >
                  Update Lat/Long
                </button>
              </div>

              <div
                class="form-group"
                :class="{ 'has-error': form.errors.has('city') }"
              >
                <label class="control-label"
                  >City <span class="optional">(optional)</span></label
                >
                <input
                  type="text"
                  class="form-control"
                  id="city"
                  v-model="form.data.city"
                />
                <span
                  class="help-block"
                  v-if="form.errors.has('city')"
                  v-text="form.errors.get('city')"
                ></span>
              </div>

              <div
                class="form-group"
                :class="{ 'has-error': form.errors.has('stateId') }"
              >
                <label class="control-label"
                  >State <span class="optional">(optional)</span></label
                >
                <div class="form-group">
                  <select class="form-control" v-model="form.data.stateId">
                    <option></option>
                    <option v-for="item in states" v-bind:value="item.id">{{
                      item.attributes.name
                    }}</option>
                  </select>
                </div>
                <span
                  class="help-block"
                  v-if="form.errors.has('stateId')"
                  v-text="form.errors.get('stateId')"
                ></span>
              </div>

              <div
                class="form-group"
                :class="{ 'has-error': form.errors.has('zip') }"
              >
                <label class="control-label"
                  >Zip <span class="optional">(optional)</span></label
                >
                <input
                  type="text"
                  class="form-control"
                  id="zip"
                  v-model="form.data.zip"
                />
                <span
                  class="help-block"
                  v-if="form.errors.has('zip')"
                  v-text="form.errors.get('zip')"
                ></span>
              </div>

              <div
                class="form-group"
                :class="{ 'has-error': form.errors.has('zoneId') }"
              >
                <label class="control-label"
                  >Zone <span class="optional">(optional)</span></label
                >
                <div class="form-group">
                  <select class="form-control" v-model="form.data.zoneId">
                    <option></option>
                    <option v-for="item in zones" v-bind:value="item.id">{{
                      item.attributes.name
                    }}</option>
                  </select>
                </div>
                <span
                  class="help-block"
                  v-if="form.errors.has('zoneId')"
                  v-text="form.errors.get('zoneId')"
                ></span>
              </div>

              <div
                class="form-group"
                :class="{ 'has-error': form.errors.has('municipalityId') }"
              >
                <label class="control-label"
                  >Municipality <span class="optional">(optional)</span></label
                >
                <div class="form-group">
                  <select
                    class="form-control"
                    v-model="form.data.municipalityId"
                  >
                    <option></option>
                    <option
                      v-for="item in municipalities"
                      v-bind:value="item.id"
                      >{{ item.attributes.name }}</option
                    >
                  </select>
                </div>
                <span
                  class="help-block"
                  v-if="form.errors.has('municipalityId')"
                  v-text="form.errors.get('municipalityId')"
                ></span>
              </div>

              <div
                class="form-group"
                :class="{ 'has-error': form.errors.has('habitatId') }"
              >
                <label class="control-label"
                  >Habitat <span class="optional">(optional)</span></label
                >
                <div class="form-group">
                  <select class="form-control" v-model="form.data.habitatId">
                    <option></option>
                    <option v-for="item in habitats" v-bind:value="item.id">{{
                      item.attributes.name
                    }}</option>
                  </select>
                </div>
                <span
                  class="help-block"
                  v-if="form.errors.has('habitatId')"
                  v-text="form.errors.get('habitatId')"
                ></span>
              </div>

              <div
                class="form-group"
                :class="{ 'has-error': form.errors.has('trapScheduleStart') }"
              >
                <label class="control-label"
                  >Trap Schedule Start
                  <span class="optional">(optional)</span></label
                >
                <date-picker
                  v-model="form.data.trapScheduleStart"
                ></date-picker>
                <span
                  class="help-block"
                  v-if="form.errors.has('trapScheduleStart')"
                  v-text="form.errors.get('trapScheduleStart')"
                ></span>
              </div>

              <div
                class="form-group"
                :class="{
                  'has-error': form.errors.has('trapScheduleFrequency'),
                }"
              >
                <label class="control-label"
                  >Trap Frequency
                  <span class="optional">(optional)</span></label
                >
                <input
                  type="text"
                  class="form-control"
                  id="trapScheduleFrequency"
                  v-model="form.data.trapScheduleFrequency"
                />
                <span
                  class="help-block"
                  v-if="form.errors.has('trapScheduleFrequency')"
                  v-text="form.errors.get('trapScheduleFrequency')"
                ></span>
              </div>

              <div
                class="form-group"
                :class="{ 'has-error': form.errors.has('larvalScheduleStart') }"
              >
                <label class="control-label"
                  >Larval Schedule Start
                  <span class="optional">(optional)</span></label
                >
                <date-picker
                  v-model="form.data.larvalScheduleStart"
                ></date-picker>
                <span
                  class="help-block"
                  v-if="form.errors.has('larvalScheduleStart')"
                  v-text="form.errors.get('larvalScheduleStart')"
                ></span>
              </div>

              <div
                class="form-group"
                :class="{
                  'has-error': form.errors.has('larvalScheduleFrequency'),
                }"
              >
                <label class="control-label"
                  >Larval Frequency
                  <span class="optional">(optional)</span></label
                >
                <input
                  type="text"
                  class="form-control"
                  id="larvalScheduleFrequency"
                  v-model="form.data.larvalScheduleFrequency"
                />
                <span
                  class="help-block"
                  v-if="form.errors.has('larvalScheduleFrequency')"
                  v-text="form.errors.get('larvalScheduleFrequency')"
                ></span>
              </div>

              <div
                class="form-group"
                :class="{
                  'has-error': form.errors.has('adulticideScheduleStart'),
                }"
              >
                <label class="control-label"
                  >Adulticide Schedule Start
                  <span class="optional">(optional)</span></label
                >
                <date-picker
                  v-model="form.data.adulticideScheduleStart"
                ></date-picker>
                <span
                  class="help-block"
                  v-if="form.errors.has('adulticideScheduleStart')"
                  v-text="form.errors.get('adulticideScheduleStart')"
                ></span>
              </div>

              <div
                class="form-group"
                :class="{
                  'has-error': form.errors.has('adulticideScheduleFrequency'),
                }"
              >
                <label class="control-label"
                  >Adulticide Frequency
                  <span class="optional">(optional)</span></label
                >
                <input
                  type="text"
                  class="form-control"
                  id="adulticideScheduleFrequency"
                  v-model="form.data.adulticideScheduleFrequency"
                />
                <span
                  class="help-block"
                  v-if="form.errors.has('adulticideScheduleFrequency')"
                  v-text="form.errors.get('adulticideScheduleFrequency')"
                ></span>
              </div>

              <loading-button
                :loading="form.loading"
                class="btn btn-primary"
                :disabled="form.errors.any()"
                >Save</loading-button
              >
              <button
                type="button"
                class="btn btn-default"
                data-dismiss="modal"
              >
                cancel
              </button>
            </form>
          </div>
          <div class="modal-footer"></div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
    <!-- /.modal -->
    <polygon-modal :opened="editingPolygon" />
  </div>
</template>

<script>
import loadGoogleMaps, { getGeocodeAddress } from '@/utils/google-maps';
import LoadingButton from '@/components/loading-button';
import DatePicker from '@/components/date-picker';
import CoordinateEditor from './coordinate-editor/coordinate-editor';
import PolygonModal from './coordinate-editor/polygon-modal';
import Point from '@/store/models/point';
import { mapState, mapGetters } from 'vuex';

export default {
  name: 'site-form',

  props: ['form'],

  components: {
    LoadingButton,
    DatePicker,
    CoordinateEditor,
    PolygonModal,
  },

  methods: {
    onSubmit: function(e) {
      this.form.data.coordinates = this.coordinatesFromGeoJSON(this.geojson);
      this.form.data.additionalCoordinates = this.additionalCoordinatesFromGeoJSON(
        this.geojson
      );
      this.form.onSubmit({ updateStore: true });
    },

    parseJSON(jsonOrString) {
      if (typeof jsonOrString == 'string') {
        return JSON.parse(jsonOrString);
      } else {
        return jsonOrString;
      }
    },

    tryGeocodeAddress(e) {
      e = e || window.event;
      e.preventDefault();

      const $this = this;
      const { address, city, zip } = $this.form.data;
      if (!address || !city || !zip) {
        toastr.error('Address, city, and zip required for geocoding.');
        return;
      }

      const callback = (geocodedLocation) => {
        this.$store.commit('setLat', geocodedLocation.lat);
        this.$store.commit('setLng', geocodedLocation.lng);
        $this.form.data.geojson = geocodedLocation;
      };
      const fullAddress = `${address}, ${city} ${zip}`;

      this.geocodeAddress({ address: fullAddress }, callback);
    },

    coordinatesFromGeoJSON(geojson) {
      if (geojson.geometry.type == 'Point') {
        var geoJSONCoordinates = geojson.geometry.coordinates;
        var pointCoordinatesEntry = {
          lat: geoJSONCoordinates[1].toString(),
          lon: geoJSONCoordinates[0].toString(),
        };
        return [pointCoordinatesEntry];
      } else if (geojson.geometry.type == 'MultiPolygon') {
        var geoJSONCoordinateSet = geojson.geometry.coordinates[0];
        var coordinatesArray = [];
        geoJSONCoordinateSet.forEach((geoJSONCoordinates, index) => {
          if (index != geoJSONCoordinateSet.length - 1) {
            coordinatesArray.push({
              lat: geoJSONCoordinates[1].toString(),
              lon: geoJSONCoordinates[0].toString(),
            });
          }
        });
        return coordinatesArray;
      } else {
        return null;
      }
    },

    additionalCoordinatesFromGeoJSON(geojson) {
      if (geojson.geometry.type == 'MultiPolygon') {
        var geoJSONCoordinateSets = geojson.geometry.coordinates;
        var coordinates = geoJSONCoordinateSets.map((geoJSONCoordinateSet) => {
          var coordinatesArray = [];
          geoJSONCoordinateSet.forEach((geoJSONCoordinates, index) => {
            if (index != geoJSONCoordinateSet.length - 1) {
              coordinatesArray.push({
                lat: geoJSONCoordinates[1].toString(),
                lon: geoJSONCoordinates[0].toString(),
              });
            }
          });
          return {
            coordinateSet: coordinatesArray,
          };
        });
        coordinates.splice(0, 1);
        return coordinates;
      } else {
        return null;
      }
    },
  },

  computed: {
    ...mapState({
      lat: (state) => state.coordinateEditor.lat,
      lng: (state) => state.coordinateEditor.lng,
      geojson: (state) => state.coordinateEditor.geojson,
      editingPolygon: (state) => state.coordinateEditor.editingPolygon,
    }),

    ...mapGetters(['coordinateMode', 'center']),

    contracts() {
      return this.$store.getters.contracts;
    },
    counties() {
      return this.$store.getters.counties;
    },
    routes() {
      return this.$store.getters.routes;
    },
    municipalities() {
      return this.$store.getters.municipalities;
    },
    habitats() {
      return this.$store.getters.habitats;
    },
    waters() {
      return this.$store.getters.waters;
    },
    states() {
      return this.$store.getters.states;
    },
    zones() {
      return this.$store.getters.zones;
    },
  },

  // updated() {
  //   let geojson = this.parseJSON(this.form.data.geojson)

  //   if (geojson && geojson.geometry) {
  //     this.$store.commit('setGeoJSON', geojson);
  //     this.$store.commit('setCoordinates', this.center)
  //   } else {
  //     this.$store.commit('setGeoJSON', Point.default().toGeoJSON())
  //     this.$store.commit('setLat', undefined)
  //     this.$store.commit('setLng', undefined)
  //   }
  // },

  mounted() {
    const $this = this;
    loadGoogleMaps(() => {
      $this.google = window.google;
      $this.geocodeAddress = getGeocodeAddress($this.google);
    });
  },
};
</script>
